module.exports = __webpack_public_path__ + "static/media/MC.1810e151.svg";